/* istanbul ignore file */
export enum PageTitles {
  proprietaryFertilizersOverview = 'proprietaryFertilizersOverview',
  editProprietaryFertilizer = 'editProprietaryFertilizer',
  createProprietaryFertilizer = 'createProprietaryFertilizer',
}
